// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__303Kn","largestCol":"styles_largestCol__PwsNX","smallestCol":"styles_smallestCol__1Zeod"};